export enum TipoRecorrenciaEnum {
    Semanal = 1,
    Mensal = 2,
}